export const formatSeasonNumber = (number: number): string => `S${number.toString().padStart(2, "0")}`

export const formatEpisodeNumber = (number: number): string => `E${number.toString().padStart(2, "0")}`
